import React, { Component, Fragment } from 'react'
import MUIDataTable from "mui-datatables";
import { Link } from 'react-router-dom'
import CreateTestIcon from '@material-ui/icons/InsertDriveFile'
import fbConfig from '../../../../config/firebaseConfig'
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles';


const columns = ["Name", "DateOfBirth","Trainer", "Number Of Tests", "Run test"];

 class Table extends Component {

    state = {
        members:[]
    }
    getMuiTheme = () => createMuiTheme({
      overrides: {
        MUIDataTable: {
          root: {
            fontSize: '1em',
          },
        },
        MUIDataTableBodyRow: {
          root: {
            '&:nth-child(odd)': { 
              backgroundColor: '#f2f2f2'
            }
          }
        },
        MuiPaper: {
          root: {
            boxShadow: "none !important",
          }
        },
        MuiTableCell: {
          body: {
          fontSize: '1em',
          }
        },
        MuiCheckbox:{
          root: {
            
              color: '#737373 !Important',
              '&:checked': { 
                color: '#c6c6c6 !Important'
              }
         
          },
          
       
          
         
        }

      }
    })
    getData = async () => {
        const db = fbConfig.firestore();
        // let userId = this.props.auth;
        let companyId = this.props.companyId
        db.collection(companyId).doc('companyUsers').collection('clients')
          .get()
          .then(querySnapshot => {
            querySnapshot.forEach(doc => {
              let data = doc.data();
              this.setState({
                members: [...this.state.members, data],
              });
              
            });
          });
      };
      initialize = async () => {
        await this.getData();
      }
      componentDidMount() {  
        this.initialize();
    }
    options = {
       onRowsDelete: (rowsDeleted)=> {
         rowsDeleted.data.forEach( row => {
           //console.log(row.dataIndex)
           let  dataRow = row.dataIndex
           const item = this.state.members[dataRow];
            //console.log(item)
            const memberId = item.email
            //console.log('mId', mId)
            this.props.deleteSelected(memberId)
        })
       //  console.log('dataRow', rowsDeleted.data);

    
       },
       //serverSide: true,
        filterType: "dropdown",
        responsive: "scroll",
        hasIndex: true,
        expandableRows: true,
        //filterType: 'checkbox',
       
      };
    render() {
        // console.log("Table props::", this.props)
        // console.log("Table state::", this.state)
        return (
            <Fragment>
            <MuiThemeProvider theme={this.getMuiTheme()}>
                <MUIDataTable
                    
                       //title={}
                        //data={data}
                        columns={columns}
                        options={this.options}
                        data={this.state.members.map(item => {
                              return [
                                  item.name,
                                  item.dob,
                                  item.trainer,
                                  item.NoTests,
                                  <Link to='/test'><CreateTestIcon/></Link>,
                              ]
                          })}
                       
                  />
                  </MuiThemeProvider>
            </Fragment>
        )
    }
}
export default Table